import axios from 'axios';

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

function normalizeResponse(response) {
  return response.data;
}

function getMessageError(error) {
  if (error.data) {
    if (error.data.message) {
      return error.data.message;
    }
    if (error.data.description) {
      return error.data.description;
    }
  }
  return null;
}

function handleError({ response }) {
  const error = {
    code: response.status,
    message: getMessageError(response)
  };
  throw error;
}

export default function request(
  url,
  options = { method: 'GET' },
  normalizeR = true
) {
  return axios({
    method: options.method,
    withCredentials: true,
    url,
    ...options
  })
    .then(checkStatus)
    .then(normalizeR ? normalizeResponse : response => response)
    .catch(handleError);
}
